<template>
  <q-section v-bind="$attrs" :bg-i="uiMeta.images.teamYestodayTop1Bg">
    <q-section :bg-i="yesterdayTopData?.user1?.avatar_url || uiMeta.images?.teamEmptyBg"
      v-bind="uiMeta.layout.wrapper.teamYestodayTop1Wrapper"
      :key="yesterdayTopData?.user1?.avatar_url || uiMeta.images?.teamEmptyBg" bdr="50%"></q-section>
    <q-section :bg-i="yesterdayTopData?.user2?.avatar_url || uiMeta.images?.teamEmptyBg"
      v-bind="uiMeta.layout.wrapper.teamYestodayTop2Wrapper"
      :key="yesterdayTopData?.user2?.avatar_url || uiMeta.images?.teamEmptyBg" bdr="50%"></q-section>
  </q-section>
</template>

<script setup lang="ts">
import { defaultConfig as uiMeta, useTeam } from './use-team'
const { yesterdayTopData } = useTeam(uiMeta)
</script>

<style scoped lang="scss"></style>
